<template>
  <b-modal
    id="ModalProduto"
    no-close-on-backdrop
    no-close-on-esc
    size="lg"
    header-class="modal-produto-header modal-eraser-header"
    footer-class="modal-produto-footer"
    ok-title="salvar"
    ok-variant="success"
    :ok-disabled="loadingInserir"
    :cancel-disabled="loadingInserir"
    primary-title="teste"
    cancel-title="Cancelar"
    auto-focus-button
    @ok.prevent="inserirProduto"
    @cancel="closeModal"
    class="modal-interno"
    @shown="modalAberto"
    @hidden="modalFechado"
  >
    <!-- {{ produtosForm }} -->
    <LoadingPadraoContainer
      v-if="loadingInserir"
      class="loading-padrao-backdrop"
      background
      :fraseLoading="[exibicaoLoading, 'Aguarde um momento']"
      delay="5000"
      classe="azul"
    />
    <Header :titulo="exibicaoTitulo" :close="closeModal" slot="modal-header" />
    <div v-if="modalEstado">
      <div
        v-if="titulo != 'monitoria' && titulo != 'adicionar_monitoria' && titulo != 'editar-lote'"
        class="modal-produto-body"
      >
        <ModalProdutoDescricao
          :produtosForm="produtosForm"
          :exibeValidacao="exibeValidacao"
          :validaCampos="validaCampos"
        />
        <div class="separador-produto"></div>
        <ModalProdutoNome
          :produtosForm="produtosForm"
          :exibeValidacao="exibeValidacao"
          :validaCampos="validaCampos"
        />
        <div class="separador-produto"></div>
        <ModalProdutoDetalhes
          :produtosForm="produtosForm"
          :exibeValidacao="exibeValidacao"
          :validaCampos="validaCampos"
        />
        <div class="separador-produto"></div>
        <ModalProdutoDestinacao
          :produtosForm="produtosForm"
          :exibeValidacao="exibeValidacao"
          :validaCampos="validaCampos"
        />
      </div>

      <div class="modal-produto-lote" v-if="titulo == 'editar-lote'">
        <Paginacao
          semGrid="30"
          produtos
          :conteudo="arProdutoEditar"
          @pagina="p => (arProdutoEditarPaginado = p)"
        >
          <TabelaPadrao
            compacto
            templateColumns="120px 50px 100px 2fr 1fr 1fr"
            :conteudoPaginado="arProdutoEditarPaginado"
            :conteudoTotal="arProdutoEditar"
            :estruturaTabela="estruturaTabela"
          />
        </Paginacao>
      </div>

      <Header
        v-if="titulo != 'monitoria' && titulo != 'adicionar_monitoria'"
        secundario
        titulo="MONITORAMENTO DE TRIBUTOS"
      />

      <InputAdicionarProduto
        v-if="titulo == 'adicionar_monitoria'"
        @selecionaProduto="selecionaProduto"
        @adicionar="transformaAdicionar"
        :produtosCadastrados="produtosCadastrados"
        :atualizaModal="atualizaModal"
      />

      <MonitoramentoDescricao v-if="titulo == 'monitoria'" :produtosForm="produtosForm" />

      <div
        v-if="produtoData && (produtoData.ncm.length == 12 || produtoData.vigente != 1)"
        class="alerta-nbm-box"
      >
        <div class="alerta-nbm-titulo">
          <font-awesome-icon class="fa-1x" icon="exclamation-circle" />
          <p>
            Não é possível monitorar este produto
          </p>
        </div>
        <p>
          identificamos que o código <strong> {{ produtosForm.ncm }} </strong> não encontra-se mais
          vigente ou foi alterado. <br />
          Por favor, selecione uma NCM correlacionada na tela anterior.
        </p>
      </div>

      <div v-else class="modal-produto-body modal-produto-monitoramento">
        <ModalMonitoramentoProduto
          :icmsEstado="produtosForm.icms_estado"
          :arTributos="produtosForm.arTributos"
          @icms="icms => (produtosForm.icms_estado = icms)"
          @impostos="impostos => (produtosForm.arTributos = impostos)"
        />
      </div>
    </div>
    <template slot="modal-footer">
      <BotaoPadrao
        arredondadoEsquerda
        class="botao-padding"
        nome="Cancelar"
        icone="times"
        :click="closeModal"
        :desabilita="loadingInserir"
      />
      <BotaoPadrao
        v-if="blUsuarioPro"
        arredondadoEsquerda
        class="botao-padding"
        nome="Salvar"
        icone="check"
        :click="inserirProduto"
        cor="azul"
        desabilita
        tooltip="Opção desabilitada na versão de testes"
      />
      <BotaoPadrao
        v-else
        arredondadoEsquerda
        class="botao-padding"
        nome="Salvar"
        icone="check"
        :click="inserirProduto"
        cor="azul"
        :desabilita="loadingInserir"
      />
    </template>
  </b-modal>
</template>

<script>
import InputAdicionarProduto from "./InputAdicionarProduto.vue";
import ModalMonitoramentoProduto from "./ModalMonitoramentoProduto.vue";
import ModalProdutoDescricao from "./ModalProdutoDescricao.vue";
import ModalProdutoDestinacao from "./ModalProdutoDestinacao.vue";
import ModalProdutoDetalhes from "./ModalProdutoDetalhes.vue";
import ModalProdutoNome from "./ModalProdutoNome.vue";
import MonitoramentoDescricao from "./MonitoramentoDescricao.vue";
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";
import Header from "@/components/ModalComponente/Header.vue";
import Paginacao from "@/components/Paginacao/Paginacao.vue";
import TabelaPadrao from "@/components/TabelaPadrao/TabelaPadrao.vue";
import LoadingPadraoContainer from "@/components/LoadingPadrao/LoadingPadraoContainer.vue";

import Api from "@/services/api.js";
import { mapGetters } from "vuex";

export default {
  name: "ModalProduto",
  components: {
    ModalProdutoDescricao,
    ModalProdutoDestinacao,
    ModalProdutoDetalhes,
    ModalProdutoNome,
    ModalMonitoramentoProduto,
    MonitoramentoDescricao,
    InputAdicionarProduto,
    BotaoPadrao,
    Header,
    Paginacao,
    TabelaPadrao,
    LoadingPadraoContainer
  },
  inject: ["pushAlert"],
  props: {
    atualizaModal: Boolean,
    produtosLength: Number,
    titulo: String,
    produtoData: Object,
    produtosCadastrados: Array,
    arProdutoEditar: Array
  },
  provide() {
    return {
      calculaProdutosForm: this.calculaProdutosForm,
      calculaProdutos: this.calculaProdutos
    };
  },
  data() {
    return {
      modalEstado: false,
      estruturaTabela: [
        { nome: "NCM", valor: "ncm", alinhamento: "centro" },
        { nome: "EX", valor: "ex", alinhamento: "centro" },
        { nome: "CEST", valor: "cest", alinhamento: "centro" },
        { nome: "PRODUTO", valor: "nome" },
        { nome: "FABRICANTE", valor: "fabricante", alinhamento: "centro" },
        { nome: "MARCA", valor: "marca", alinhamento: "centro" }
      ],
      exibeValidacao: false,
      loadingInserir: false,
      arProdutoEditarPaginado: [],
      ex: "-",
      cest: "-",
      produtosForm: {
        id_empresa: "",
        codigo_produto: "",
        id: "",
        ex: "0",
        cest: "0",
        ncm: "",
        nome: "",
        fabricante: "",
        marca: "",
        ean: "",
        icms_estado: [],
        arTributos: [
          "",
          "",
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false
        ],
        id_destinacao: ""
      }
    };
  },
  mounted() {
    this.produtosForm.id_empresa = this.getEmpresa && this.getEmpresa.id ? this.getEmpresa.id : "";
  },
  watch: {
    ex() {
      if (this.ex == "-") {
        this.produtosForm.ex = "0";
      } else {
        this.produtosForm.ex = this.ex;
      }
    },
    cest() {
      if (this.cest == "-") {
        this.produtosForm.cest = "0";
      } else {
        this.produtosForm.cest = this.cest;
      }
    },
    getEmpresa() {
      this.produtosForm.id_empresa =
        this.getEmpresa && this.getEmpresa.id ? this.getEmpresa.id : "";
    },
    atualizaModal: {
      deep: true,
      handler() {
        this.produtosForm.id_empresa =
          this.getEmpresa && this.getEmpresa.id ? this.getEmpresa.id : "";

        if (this.titulo == "editar" || this.titulo == "monitoria") {
          let monitoria =
            this.titulo == "editar"
              ? this.produtoData.monitoria.map(p => p.id_tipo_monitoria)
              : this.produtoData.data_monitoramento.map(p => p.id_tipo_monitoria);

          this.produtosForm.id = this.produtoData.id;
          this.produtosForm.ex = this.produtoData.ex;
          this.produtosForm.cest = this.produtoData.cest;
          this.produtosForm.ncm = this.produtoData.ncm;
          this.produtosForm.nome = this.produtoData.nome;
          this.produtosForm.codigo_produto =
            this.produtoData.codigo_produto == "-" ? "" : this.produtoData.codigo_produto;
          this.produtosForm.fabricante =
            this.produtoData.fabricante == "-" ? "" : this.produtoData.fabricante;
          this.produtosForm.marca = this.produtoData.marca == "-" ? "" : this.produtoData.marca;
          this.produtosForm.ean = this.produtoData.ean == "-" ? "" : this.produtoData.ean;
          this.produtosForm.icms_estado =
            this.titulo == "editar"
              ? this.produtoData.icms_estado.map(p => p.id_estado)
              : this.produtoData.icms_estado;
          this.produtosForm.arTributos = [
            "",
            "",
            monitoria.includes("2"),
            monitoria.includes("3"),
            monitoria.includes("4"),
            monitoria.includes("5"),
            monitoria.includes("6"),
            monitoria.includes("7"),
            false,
            false,
            false,
            false,
            monitoria.includes("12")
          ];
          this.produtosForm.id_destinacao = this.produtoData.id_destinacao;
        } else {
          this.produtosForm.codigo_produto = "";
          this.produtosForm.id = "";
          this.ex = "-";
          this.cest = "-";
          this.produtosForm.ncm = "";
          this.produtosForm.nome = "";
          this.produtosForm.fabricante = "";
          this.produtosForm.marca = "";
          this.produtosForm.ean = "";
          this.produtosForm.icms_estado = [];
          this.produtosForm.arTributos = [
            "",
            "",
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false
          ];
          this.produtosForm.id_destinacao = "";
        }
      }
    },
    produtosForm: {
      deep: true,
      handler() {
        if (
          this.produtosForm.nome != "" &&
          this.produtosForm.ncm != "" &&
          this.produtosForm.id_destinacao != ""
        ) {
          this.exibeValidacao = false;
        }
      }
    },
    "produtosForm.ncm": {
      deep: true,
      handler() {
        this.ex = "-";
        this.cest = "-";
      }
    }
  },
  computed: {
    ...mapGetters("empresa", ["getEmpresa"]),
    ...mapGetters("auth", {
      blUsuarioPro: "getUsuarioPro"
    }),
    // blUsuarioPro() {
    //   return true
    // },
    produtosPayload() {
      let produtos = { ...this.produtosForm };
      if (produtos.ex == "-") {
        produtos.ex = "0";
      }
      if (produtos.cest == "-") {
        produtos.cest = "0";
      }
      return produtos;
    },
    exibicaoTitulo() {
      if (
        this.titulo != "monitoria" &&
        this.titulo != "adicionar_monitoria" &&
        this.titulo != "editar-lote"
      ) {
        return `${this.titulo} produto`;
      } else if (this.titulo != "editar-lote") {
        return "MONITORAMENTO DE TRIBUTOS";
      }
      return "Editar Produtos";
    },
    exibicaoLoading() {
      if (
        this.titulo != "monitoria" &&
        this.titulo != "adicionar_monitoria" &&
        this.titulo != "editar-lote"
      ) {
        return this.titulo == "editar" ? "Editando produto" : "Cadastrando produto";
      } else if (this.titulo != "editar-lote") {
        return "Moniorando produtos";
      }
      return "Editando produtos";
    },
    validaCampos() {
      let valida = {
        ncm: this.produtosForm.ncm == "" ? true : false,
        nome: this.produtosForm.nome == "" ? true : false,
        destinacao: this.produtosForm.id_destinacao == "" ? true : false
      };
      let requeridoFiltrado = Object.fromEntries(
        Object.entries(valida).filter(([_, value]) => value == true)
      );
      return requeridoFiltrado;
    }
    // arProdutoEditarFiltrado() {
    //   if (this.arProdutoEditarPaginado) {
    //     let lista = [...this.arProdutoEditarPaginado.map(produto => ({ ...produto }))];
    //     lista.forEach(e => {
    //       e.ex = e.ex == 0 ? "-" : e.ex;
    //       e.cest = e.cest == 0 ? "-" : e.cest;
    //     });
    //     return lista;
    //   }
    //   return [];
    // }
  },
  methods: {
    modalAberto() {
      this.modalEstado = true;
    },
    modalFechado() {
      this.modalEstado = false;
    },
    transformaAdicionar() {
      this.limpaModal();
      this.$emit("adicionar");
    },
    selecionaProduto(selecionado) {
      this.produtosForm.id = selecionado ? selecionado.id : "";
      this.produtosForm.ex = selecionado ? selecionado.ex : "";
      this.produtosForm.cest = selecionado ? selecionado.cest : "";
      this.produtosForm.ncm = selecionado ? selecionado.ncm : "";
      this.produtosForm.nome = selecionado ? selecionado.nome : "";
      this.produtosForm.codigo_produto =
        selecionado && selecionado.codigo_produto != "-" ? selecionado.codigo_produto : "";
      this.produtosForm.fabricante =
        selecionado && selecionado.fabricante != "-" ? selecionado.fabricante : "";
      this.produtosForm.marca = selecionado && selecionado.marca != "-" ? selecionado.marca : "";
      this.produtosForm.ean = selecionado && selecionado.ean != "-" ? selecionado.ean : "";
      this.produtosForm.id_destinacao = selecionado ? selecionado.id_destinacao : "";
    },
    calculaProdutosForm(dado, campo) {
      this.produtosForm[campo] = dado;
    },
    calculaProdutos(dado, campo) {
      this[campo] = dado;
    },
    limpaModal() {
      this.produtosForm = {
        id_empresa: this.getEmpresa && this.getEmpresa.id ? this.getEmpresa.id : "",
        codigo_produto: "",
        id: "",
        ex: "0",
        cest: "0",
        ncm: "",
        nome: "",
        fabricante: "",
        marca: "",
        ean: "",
        icms_estado: [],
        arTributos: [
          "",
          "",
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false
        ],
        id_destinacao: ""
      };
    },
    closeModal() {
      if (this.loadingInserir) return;
      this.limpaModal();
      this.$root.$emit("bv::hide::modal", "ModalProduto");
    },
    async inserirProduto() {
      if (this.loadingInserir) return;
      if (Object.values(this.validaCampos).length && this.titulo != "editar-lote") {
        this.exibeValidacao = true;
        this.pushAlert("É necessário preencher os campos obrigatórios!", "danger");
        return;
      }
      let totalProdutos = JSON.parse(localStorage.getItem("assinatura")).qtde_produto;
      if (this.produtosLength >= totalProdutos && this.titulo == "adicionar") {
        this.pushAlert("Limite máximo de produtos atingido!", "danger");
        return;
      }
      this.loadingInserir = true;
      // ADICIONANDO OU EDITANDO PRODUTO
      this.exibeValidacao = false;
      if (this.titulo == "adicionar") {
        let adicionar = await this.adicionarProduto();
        if (adicionar == "duplicado" || adicionar == "erro") return;
      } else if (this.titulo == "editar") {
        let editar = await this.editarProduto();
        if (editar == "erro") return;
      }
      // ALTERANDO MONITORIA OU LOTE DE MONITORIA
      if (this.titulo == "editar-lote") {
        let lote = await this.editarLote();
        if (lote == "erro") return;
      } else {
        let monitoria = await this.editarMonitoria();
        if (monitoria == "erro") return;
      }

      this.$emit("atualiza");
      this.loadingInserir = false;
      this.closeModal();
    },
    async adicionarProduto() {
      try {
        const response = await new Api().post("Produto/inserirProduto", this.produtosPayload);
        if (response.mensagem == "duplicado") {
          this.pushAlert("Produto duplicado!", "warning");
          this.loadingInserir = false;
          return "duplicado";
        }
        this.produtosForm.id = response.dados.id;
      } catch (error) {
        console.error(error);
        this.pushAlert("Erro ao adicionar produto! Tente novamente mais tarde.", "danger");
        this.loadingInserir = false;
        return "erro";
      }
      return "adicionar";
    },
    async editarProduto() {
      try {
        await new Api().post(
          `Produto/alterarProduto/${this.produtosPayload.id}`,
          this.produtosPayload
        );
      } catch (error) {
        console.error(error);
        this.pushAlert("Erro ao alterar produto! Tente novamente mais tarde.", "danger");
        this.loadingInserir = false;
        return "erro";
      }
      return "editar";
    },
    async editarMonitoria() {
      try {
        const responseMonitoria = await new Api().post(
          "Produto/inserirProdutoMonitoria",
          this.produtosForm
        );
        if (responseMonitoria.status) {
          if (this.titulo == "editar" || this.titulo == "monitoria") {
            this.pushAlert("Produto alterado com sucesso!", "success");
          } else {
            this.pushAlert("Produto cadastrado com sucesso!", "success");
          }
        }
        return "editar";
      } catch (error) {
        console.error(error);
        if (this.titulo == "editar" || this.titulo == "monitoria") {
          this.pushAlert("Erro ao alterar produto! Tente novamente mais tarde.", "danger");
        } else {
          this.pushAlert("Erro ao cadastrar produto! Tente novamente mais tarde.", "danger");
        }
        this.loadingInserir = false;
        return "erro";
      }
    },
    async editarLote() {
      let produtos_id = this.arProdutoEditar.map(p => p.id);
      let promises = [];

      this.produtosForm.produtos_id = produtos_id;

      try {
        let promise = new Api().post("Produto/alterarProdutoMonitoria", this.produtosPayload);
        promises.push(promise);
      } catch (error) {
        console.error(error);
        this.pushAlert("Erro ao alterar produtos! Tente novamente mais tarde.", "danger");
        this.loadingInserir = false;
        return "erro";
      }

      let responseMonitoriaLote = await Promise.all(promises); // aguarda todas as promessas serem resolvidas
      let sucesso = responseMonitoriaLote.map(response => response.status).every(p => p == true);
      if (sucesso) {
        this.pushAlert("Produtos alterados com sucesso!", "success");
      } else {
        this.pushAlert("Erro ao atualizar produtos!", "danger");
      }
      return "lote";
    }
  }
};
</script>

<style lang="scss">
.alerta-nbm-box {
  border: 1px solid #900;
  border-radius: 6px;
  margin: 30px 60px;

  text-align: center;
}
.alerta-nbm-titulo {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
  color: #900;
  p {
    margin-left: 5px;
    font-weight: bold;
    color: #1d1d1d !important;
    margin-bottom: 0 !important;
  }
}

.linha-vermelha {
  background-color: #a4091956;

  color: #900;
}

.icon-container {
  position: absolute;
  float: left;
  margin-top: 4px;
  margin-left: -20px;
  color: #900;
}

.modal-produto-header {
  color: var(--vermelho3);
  background: var(--cinza0);
  border-bottom: 1px solid var(--cinza03);
  text-align: center;
  padding-bottom: 1rem !important;
}
.modal-produto-header .modal-produto {
  width: 100%;
}
.modal-produto-header .modal-produto button.close {
  position: absolute;
  top: 16px;
  right: 16px;
}
.modal-produto-header .fa-times-circle {
  font-size: 70px;
  margin-bottom: 10px;
  margin-top: 10px;
}

.modal-produto-body {
  text-align: center;
  margin-bottom: 15px;
}
.modal-produto-footer button.btn-secondary {
  background: #9e9e9e !important;
  &:hover {
    background: #777777 !important;
  }
  &:focus {
    background: #777777 !important;
  }
}
.corpo-mensagem {
  text-align: center;
  margin-top: 7px;
  float: left;
  width: 100%;
  margin-bottom: 20px;
}
// .modal-produto-footer button {
//   padding: 4px 19px !important;
//   border-radius: 2px !important;
//   font-size: 14px !important;
//   font-weight: normal !important;
//   border: 0 !important;
//   margin: 0 0.25rem !important;
// }
.modal-produto-footer button.btn-success {
  outline: 0 !important;
  background-color: #007bff !important;

  // box-shadow: none !important;
  &:hover {
    background: #0062cc !important;
  }
  &:focus {
    background: #0062cc !important;
  }
  &:active {
    box-shadow: 0 0 0 0.2rem #b3d4fc !important;
  }
}
.modal-produto {
  .fa-x {
    color: var(--vermelho3) !important;
    cursor: pointer;
  }
}
.separador-produto {
  margin: 0.7rem 0 0.5rem 0;
}
.title-area-monitoramento {
  background: var(--cinza0);
  border-bottom: 1px solid var(--cinza03);
  border-top: 1px solid var(--cinza03);
  text-align: center;
  padding: 1rem !important;
  margin: 0 -1rem;
}
.modal-title-monitoramento {
  display: flex;
  justify-content: flex-start;
  font-family: "Roboto Condensed";
  font-weight: bold;
  color: #094466;
  font-size: 20px;
  text-transform: uppercase;
  position: relative;
  margin-bottom: 0;
}
.modal-produto-monitoramento {
  margin-top: 15px;
  margin-bottom: 0;
}
.loading-modal-produtos {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #9e9e9ea8;
  left: 0;
  top: 0;
  z-index: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 50px;
  color: var(--branco);
}
.modal-interno {
  position: relative;
}
.modal-produto-lote {
  margin-bottom: 15px;
  max-height: 250px;
  overflow-y: scroll;
  padding: 0 5px 0 15px;
}
.modal-produto-tabela {
  display: grid;
  grid-template-columns: 2fr 1fr 2fr 5fr 3fr 3fr;
  font-family: "Open Sans", sans-serif;
  border-left: 1px solid #ddd;
  border-right: 1px solid #ddd;
}
.modal-tabela-titulo {
  display: flex;
  overflow: hidden;
  background-color: var(--azul4);
  color: var(--branco);
  padding: 3px 10px;
}
.modal-tabela-corpo {
  display: flex;
  padding: 3px 10px;
  overflow: hidden;
  border-bottom: 1px solid #ddd;
}
.produto-tabela-titulo {
  border: 1px solid var(--azul4);
  border-radius: 2px 2px 0 0;
}
</style>
